"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const base_measure_component_1 = require("../base_measure.component");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_service_1 = require("../../../../../commons/map.service");
const map_component_1 = require("../../../map.component");
const tin_1 = require("@turf/tin");
const platform_browser_1 = require("@angular/platform-browser");
const measurement_helper_service_1 = require("../../../../../service/measurement-helper.service");
const entity_helper_service_1 = require("../../../../../service/entity-helper.service");
const application_events_service_1 = require("../../../../../xs/services/events/application-events.service");
const global_1 = require("../../../../../commons/global");
const epsg_helper_service_1 = require("../../../../../service/epsg-helper.service");
const coord_helper_service_1 = require("@src/app/service/coord-helper.service");
const file_manager_service_1 = require("@src/app/service/file-manager.service");
const Cesium = window.Cesium;
class VolumeComponent extends base_measure_component_1.BaseMeasure {
    constructor(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager, domSanitizer) {
        super(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager);
        this.route = route;
        this.router = router;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.mappingHelper = mappingHelper;
        this.entityHelper = entityHelper;
        this.applicationEvents = applicationEvents;
        this.epsgHelper = epsgHelper;
        this.fileManager = fileManager;
        this.domSanitizer = domSanitizer;
        this.calculatingVolumePercent = 0;
        this.calculatingVolume = false;
        this.minHeight = 'minHeight';
        this.customHeight = 'customHeight';
        this.customHeightValue = 0;
        this.baseSurface = 'baseSurface';
        this.baseDesign = 'baseDesign';
        this.volumeChoiceOption = this.baseSurface;
        /*
        chunk:number = 0;
        slice:number = 0;
      
        gridSize:number = 5;
        gridSizeX:number = 5;
        gridSizeY:number = 5;
      
        samplingDistance:number = 1.5;
        samplingDistanceCalc:number = 0;
      */
        this.gridPoints = null;
        this.finalCalculatedPoints = [];
        this.boundingHandlerId = null;
        this.boundingHandler = null;
        this.selectedIndex = 10;
        this.originalColor = null;
        this.showingGrid = false;
        this.clampToModel = true;
        /*
          redrawGeo(addEntity?: boolean) {
            try{
              super.baseRedrawGeo();
              if (this.points.length > 2) {
                this.points = this.points.filter( p => p.position);
                var posis = this.points.map(p => p.position.getValue());
                this.currentGeo = this.addVolumeBase(posis, this.currentPointsIndexLineWidth, this.currentPointsIndexColor);
                this.addLineToAnnotation(this.currentPointsIndex, this.currentGeo.id);
                this.allGeo.push(this.currentGeo);
                this.errMsg = null
              } else {
                this.errMsg = 'ERR_POINT'
              }
            }catch (e) {
              console.log(e.message);
            }
          }
        */
        this.sceneTransformsActive = [];
        this.sceneTransformsActiveViews = {};
        // console.log ( '%c volume %c constructor()', Constants._red, Constants._yellow );
        // yes, we can calculate volume
        this.canCalculate = true;
        // volume controls
        this.canCalculateVolume = true;
        // this.showCalculateOptions = true;
    }
    // super-simple plugin support
    getPlugin(id = '') {
        return this.pluginManager.get(id);
    }
    ngOnInit() {
        if (this.mapService.scene) {
            this.init();
        }
        else {
            this.addSubscription('volume-sceneChange', this.mapService.onSceneChange('volume.component').subscribe(_ => {
                this.init();
            }));
        }
    }
    init() {
        super.onInit();
        this.addSubscription('annotationReady', this.mapService.newAnnotationReady.subscribe(_ => {
            this.annotationReady();
        }));
        this.annotationReady();
    }
    ngOnDestroy() {
        super.onDestroy();
        this.removeGrid();
    }
    // ???
    ngAfterViewInit() { }
    annotationReady() {
        if (this.annotation && this.annotation['calculatedVolume']) {
            this.calculatedVolume = this.annotation['calculatedVolume'];
            this.pickedFeatureIs3D = true;
        }
    }
    annotationUpdated() {
        if (!this.zone) {
            this.zone = new coord_helper_service_1.CoordZone();
        }
        if (!this.boundingHandlerId) {
            // console.log('#####################pluginManager',this.pluginManager);
            this.boundingHandlerId = this.pluginManager.create('bounding-handler');
            if (this.boundingHandlerId) {
                this.boundingHandler = this.pluginManager.get(this.boundingHandlerId);
                this.plugins.push(this.boundingHandler);
            }
        }
        const shape = this.shapes[this.shapeMaker.selectedShape];
        // console.log( 'ZONE START', this.shapes, shape );
        if (shape && shape.points && shape.points.length) {
            let points = shape.points.map(p => p.coords);
            if (points && points.length) {
                let length = 0;
                if (shape && shape.calc && shape.calc.length) {
                    length = shape.calc.length;
                }
                this.zone.init({ cartesianArray: points, perimeterLength: length });
                if (this.boundingHandler) {
                    // this.boundingHandler.updateCoords(points);
                }
            }
        }
        // console.log( 'ZONE END', this.zone );
    }
    gridInput($event) {
        // draw grid
        this.zone.area.corners.samplingDistance = $event.value;
        this.visualizeGrid();
    }
    gridChange($event) {
        // remove grid, restore color
        this.removeGrid();
    }
    removeGrid() {
        if (!this.showingGrid) {
            // no need to remove something that isn't there ...
            return;
        }
        let e = this.entityHelper.getEntity(this.entityHelper.getEntityId(this.currentAnnotationRef, this.shapeMaker.selectedShape));
        if (e) {
            e.polygon.material = this.originalColor;
            this.showingGrid = false;
        }
    }
    visualizeGrid() {
        let e = this.entityHelper.getEntity(this.entityHelper.getEntityId(this.currentAnnotationRef, this.shapeMaker.selectedShape));
        if (e) {
            if (!this.showingGrid) {
                this.originalColor = e.polygon.material;
                this.showingGrid = true;
            }
            this.zone.createGrid();
            e.polygon.material = new Cesium.GridMaterialProperty({
                color: Cesium.Color.YELLOW,
                cellAlpha: 0.1,
                lineCount: new Cesium.Cartesian2(this.zone.area.grid.x, this.zone.area.grid.y),
                lineThickness: new Cesium.Cartesian2(1.0, 1.0)
            });
        }
        /*
        this.removeGrid();
        this.zone.area.grid.all.forEach(p => {
          this.gridPoints.push( this.mapService.viewer.entities.add({
            position: p,
            point: {
              pixelSize: 10,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              color: Cesium.Color.YELLOW.withAlpha(0.4)
            },
          }) );
        });
        console.log('!',this.zone.area.grid.all.length);
        */
    }
    // volume calculations
    // simple wrapper until we've refactored the code
    calculate() {
        // console.log ( 'Volume Calculate()');
        this.mapComp.refPin.show = false;
        this.finalCalculatedPoints = [];
        this.startCalcPolygonVolume();
    }
    finished() {
        // console.log ( 'Volume finished Calculate()');
        this.mapComp.refPin.show = true;
    }
    // start-button from the line.html template
    startCalcPolygonVolume() {
        if (this.shapeMaker.selectedShape == null) {
            console.error('trying to calculate on non-selected shape');
            return;
        }
        // refactor; these points
        let points = this.shapes[this.shapeMaker.selectedShape].points.map(p => p.coords);
        // console.log ( '%c volume %c startCalc()', Constants._red, Constants._yellow,points );
        //once started calculating volume remove old values
        this.calculatedVolume = undefined;
        this.calculatingVolume = true;
        this.calculatingVolumePercent = 0;
        if (!this.shapes[this.shapeMaker.selectedShape].calc) {
            this.shapes[this.shapeMaker.selectedShape].calc = {};
        }
        this.shapes[this.shapeMaker.selectedShape].calc['volume'] = 0;
        this.shapes[this.shapeMaker.selectedShape].calc['volumePos'] = 0;
        this.shapes[this.shapeMaker.selectedShape].calc['volumeNeg'] = 0;
        if (points.length > 2) {
            this.startCalculating();
            // if (this.pickedFeatureIs3D) {
            // this.takeScreenshot();
            this.calcPolygonVolume(points);
            // this.takeScreenShotForVolume();
            // }
            /*else{
                  this.calculatingVolume = false;
                  this.openSnackBarError('Volume can be calculated on 3D objects only');
                }*/
        }
        else if (this.selectedIndex !== -1) {
            // var posis = this.annotation['points'][this.selectedIndex].map(p =>  p['coords'])
            // if (this.pickedFeatureIs3D) {
            // this.takeScreenshot();
            this.calcPolygonVolume(points);
            // this.takeScreenShotForVolume();
            // }
            /*else{
                  this.calculatingVolume = false;
                  this.openSnackBarError('Volume can be calculated on 3D objects only');
                }*/
        }
        else {
            this.calculatingVolume = false;
        }
    }
    toRad(d) {
        return d * Math.PI / 180;
    }
    toDeg(d) {
        return d * (180 / Math.PI);
    }
    calcPolygonVolume(vertices) {
        var vLongitude = [];
        var vLatitude = [];
        var vHeight = [];
        var polyVertices = [];
        /* ******************************** HACK **** REMOVE THIS ONCE WE KNOW HOW THIS FEATURE WORK ON TERRAINS *********************************** */
        this.pickedFeatureIs3D = true;
        //console.log ( '%c volume %c calc() calc', Constants._red, Constants._yellow, vertices );
        for (var i = 0; i < vertices.length; ++i) {
            const coord = Cesium.Cartographic.fromCartesian(vertices[i]);
            vLongitude.push(coord.longitude);
            vLatitude.push(coord.latitude);
            vHeight.push(coord.height);
            polyVertices.push([coord.longitude, coord.latitude, coord.height]);
            // refactored this silliness
            // vLongitude.push(Cesium.Cartographic.fromCartesian(vertices[i]).longitude);
            // vLatitude.push(Cesium.Cartographic.fromCartesian(vertices[i]).latitude);
            // vHeight.push(Cesium.Cartographic.fromCartesian(vertices[i]).height);
            // polyVertices.push([Cesium.Cartographic.fromCartesian(vertices[i]).longitude, Cesium.Cartographic.fromCartesian(vertices[i]).latitude, Cesium.Cartographic.fromCartesian(vertices[i]).height])
        }
        // console.log ( '%c volume %c calc() vertices', Constants._red, Constants._yellow, polyVertices );
        //console.log ( '%c volume %c calc() calc 2', Constants._red, Constants._yellow, vLongitude, vLatitude, vHeight, polyVertices );
        var objectsToExclude = this.mapService.viewer.entities.values; // this.mapService.viewer.entities.values ; //[this.currentGeo, ...this.points];
        var promise;
        if (this.pickedFeatureIs3D) {
            //console.log ( '%c volume %c calc() objectsToExclude', Constants._red, Constants._yellow, objectsToExclude );
            this.calculateSamplingDistanceAndProcess(vLongitude, vLatitude, vHeight, promise, objectsToExclude, polyVertices);
        }
        else {
            promise = Cesium.sampleTerrainMostDetailed(this.mapService.viewer.terrainProvider, polyVertices);
            // console.log ( '%c volume %c calc() not 3d', Constants._red, Constants._yellow, this.mapService.viewer.terrainProvider, polyVertices, promise );
            promise.then(v => {
                // console.log ( '%c volume %c calc() not 3d promise', Constants._red, Constants._yellow, v );
                this.calculateSamplingDistanceAndProcess(vLongitude, vLatitude, vHeight, promise, objectsToExclude, polyVertices);
            });
        }
        // console.log ( '%c volume %c calc() done', Constants._red, Constants._yellow );
    }
    calculateSamplingDistanceAndProcess(vLongitude, vLatitude, vHeight, promise, objectsToExclude, polyVertices) {
        var minX = Math.min(...vLongitude);
        var minY = Math.min(...vLatitude);
        var maxX = Math.max(...vLongitude);
        var maxY = Math.max(...vLatitude);
        var minZ = Math.min(...vHeight);
        var Vol = 0;
        // console.log ( '%c volume %c calc() calc 3', Constants._red, Constants._yellow, minX, maxX, minY, maxY, minZ );
        var c1 = new Cesium.Cartographic(minX, minY, minZ);
        // var c1b= new Cesium.Cartographic(minX, minY, minZ);
        var c2 = new Cesium.Cartographic(maxX, minY, minZ);
        var c3 = new Cesium.Cartographic(minX, maxY, minZ);
        var c4 = new Cesium.Cartographic(maxX, maxY, minZ);
        var corners = [c1, c2, c3, c4];
        /* corners.forEach ( c => {
          this.mapService.viewer.entities.add({
            position: Cesium.Cartesian3.fromRadians(c.longitude,c.latitude,c.height+1),
            point: {
              pixelSize: 15,
              color: Cesium.Color.GREEN.withAlpha(0.3)
            },
          });
          console.log ( '%c volume %c calc() corner', Constants._red, Constants._yellow, c );
        }); */
        /* if ( this.debug ) {
          let cornersC3 = [
            new Cesium.Cartesian3.fromRadians(c1.longitude,c1.latitude,c1.height+100),
            new Cesium.Cartesian3.fromRadians(c2.longitude,c2.latitude,c2.height+100),
            new Cesium.Cartesian3.fromRadians(c3.longitude,c3.latitude,c3.height+100)
          ];
          this.mapService.viewer.entities.add({
            name: 'corners',
            polyline: {
              positions: cornersC3,
              width: 5,
              clampToGround : false,
              material: new Cesium.PolylineOutlineMaterialProperty({
                  color: Cesium.Color.YELLOW,
                  outlineColor: Cesium.Color.LIGHTGREY.withAlpha(0.4),
                  outlineWidth:2
              }),
            }
          });
          console.log ( '%c volume %c calc() calc 4', Constants._red, Constants._yellow, corners, cornersC3 );
        } */
        // this section manipulates the corners array and messes with the first corner's height
        const timeStart = performance.now();
        if (this.pickedFeatureIs3D) {
            promise = this.mapService.viewer.scene.sampleHeightMostDetailed(corners, objectsToExclude, 0.05);
        }
        else {
            promise = Cesium.sampleTerrainMostDetailed(this.mapService.viewer.terrainProvider, corners);
        }
        promise.then(v => {
            const timeEnd = performance.now();
            // console.log ( '%c volume %c Corners sampling', Constants._red, Constants._yellow, timeEnd - timeStart, v );
            var lc = Cesium.Cartesian3.fromRadians(corners[0].longitude, corners[0].latitude, corners[0].height);
            var lcr = Cesium.Cartesian3.fromRadians(corners[1].longitude, corners[1].latitude, corners[1].height);
            var lcu = Cesium.Cartesian3.fromRadians(corners[2].longitude, corners[2].latitude, corners[2].height);
            // console.log ( '%c volume %c Corners calculated', Constants._red, Constants._yellow, corners, lc, lcr, lcu );
            var width = Cesium.Cartesian3.distance(lc, lcr);
            var len = Cesium.Cartesian3.distance(lc, lcu);
            var samplingDistance = 1.5;
            //console.log ( '%c volume %c calc() calc 5', Constants._red, Constants._yellow, lc, lcr, lcu, width, len );
            if (width > 100 && width < 200 && len > 100 && len < 200) {
                samplingDistance = 3;
            }
            if (width > 200 && len > 200) {
                samplingDistance = 5;
            }
            if (width > 300 && len > 300) {
                samplingDistance = 6;
            }
            if (samplingDistance < 0.5) {
                samplingDistance = 1.5;
            }
            // console.log ( '%c volume %c sampling distance', Constants._red, Constants._yellow, samplingDistance );
            //console.log ( '@@@@@@', corners, width, len, samplingDistance);
            var gridSizeX = Math.floor(width / samplingDistance);
            var gridSizeY = Math.floor(len / samplingDistance);
            // pull in values from the new zone calculator
            gridSizeX = this.zone.area.grid.x;
            gridSizeY = this.zone.area.grid.y;
            var gridPositions = [];
            var gridPositionsCartographic = [];
            for (var y = 0; y < gridSizeY; ++y) {
                for (var x = 0; x < gridSizeX; ++x) {
                    var X = Cesium.Math.lerp(minX, maxX, x / (gridSizeX - 1));
                    var Y = Cesium.Math.lerp(minY, maxY, y / (gridSizeY - 1));
                    var position = new Cesium.Cartesian3.fromRadians(X, Y, 400);
                    var positionCartographic = new Cesium.Cartographic(X, Y);
                    if (this.pointInsidePolygon(positionCartographic, vLongitude, vLatitude)) {
                        gridPositions.push(position);
                        gridPositionsCartographic.push(positionCartographic);
                        // count points; if less than X, set to minimum
                        /* this.mapService.viewer.entities.add({
                          position: position,
                          point: {
                            pixelSize: 5,
                            color: Cesium.Color.GREEN
                          },
                        }); */
                    }
                    else {
                        /* this.mapService.viewer.entities.add({
                          position: position,
                          point: {
                            pixelSize: 5,
                            color: Cesium.Color.RED
                          },
                        }); */
                    }
                }
            }
            this.startCalculating(gridPositions.length);
            var gdLcr = Cesium.Cartesian2.fromCartesian3(gridPositions[0]);
            var gdLcu = Cesium.Cartesian2.fromCartesian3(gridPositions[1]);
            // console.log ( '%c volume %c grid', Constants._red, Constants._yellow, gridPositions );
            // console.log ( '%c volume %c prep', Constants._red, Constants._yellow, width, len, samplingDistance, gridSizeX, gridSizeY, Cesium.Cartesian2.distance(gdLcr, gdLcu) );
            // this.samplingDistance = samplingDistance;
            samplingDistance = Cesium.Cartesian2.distance(gdLcr, gdLcu);
            // this.samplingDistanceCalc = samplingDistance;
            var arr = polyVertices.map((p) => {
                return {
                    'type': 'Feature',
                    'geometry': { 'coordinates': [p[0] * 180 / Math.PI, p[1] * 180 / Math.PI] },
                    'properties': { 'z': p[2] }
                };
            });
            var polyPoints = {
                'type': 'FeatureCollection',
                'features': arr
            };
            var tin = tin_1.default(polyPoints, 'z');
            // get TIN faces with calculated normal per each face, check if gridPoints are within any of these TIN faces then create a plane and compute the gridPoints height from that plane
            var tinTriangles = tin.features.map((feature) => {
                var xys = feature.geometry.coordinates[0].slice(0, 3);
                var zs = [feature.properties.a, feature.properties.b, feature.properties.c];
                var cartesian3 = [
                    new Cesium.Cartesian3.fromDegrees(xys[0][0], xys[0][1], zs[0]),
                    new Cesium.Cartesian3.fromDegrees(xys[1][0], xys[1][1], zs[1]),
                    new Cesium.Cartesian3.fromDegrees(xys[2][0], xys[2][1], zs[2])
                ];
                var cartographic = [
                    new Cesium.Cartographic(xys[0][0], xys[0][1]),
                    new Cesium.Cartographic(xys[1][0], xys[1][1]),
                    new Cesium.Cartographic(xys[2][0], xys[2][1])
                ];
                var v1 = new Cesium.Cartesian3();
                var v2 = new Cesium.Cartesian3();
                Cesium.Cartesian3.subtract(cartesian3[1], cartesian3[0], v1);
                Cesium.Cartesian3.subtract(cartesian3[2], cartesian3[0], v2);
                var normal = new Cesium.Cartesian3();
                Cesium.Cartesian3.cross(v1, v2, normal);
                Cesium.Cartesian3.normalize(normal, normal);
                var plane = Cesium.Plane.fromPointNormal(cartesian3[0], normal);
                return {
                    cartesian3: cartesian3,
                    projected: cartographic,
                    plane: plane
                };
            });
            // console.log ( '%c volume %c tins', Constants._red, Constants._yellow, tinTriangles );
            var chunk = 50;
            var slice = 50;
            // this.chunk = chunk;
            // this.slice = slice;
            this.sumOfHeights = 0;
            this.batchSize = 0;
            var temp;
            if (gridPositionsCartographic.length < chunk) {
                chunk = gridPositionsCartographic.length;
            }
            temp = gridPositionsCartographic.slice(0, chunk);
            // this.endCalculating();
            // console.log ( '%c volume %c done', Constants._red, Constants._yellow, temp );
            // temporary disabled
            this.makeSamplePromise(this.mapService.viewer.scene, this, gridPositionsCartographic.length, temp, objectsToExclude, chunk, slice, gridPositionsCartographic, Vol, samplingDistance, gridPositions, tinTriangles);
        });
    }
    // actual volume calculation
    makeSamplePromise(model, ths, len, temp, objectsToExclude, chunk, slice, gridPositionsCartographic, Vol, samplingDistance, polyVertices, tinTriangles) {
        // this.calculatingVolumePercent = ((chunk * 100) / len);
        this.updateCalculationProcess(chunk);
        if (!this.calculating) {
            this.entityHelper.destroyEntitiesByCaller('volume_calc');
            this.finished();
            return;
        }
        var samplePromise;
        if (this.pickedFeatureIs3D) {
            samplePromise = model.sampleHeightMostDetailed(temp, objectsToExclude, 0.05);
        }
        else {
            samplePromise = Cesium.sampleTerrainMostDetailed(this.mapService.viewer.terrainProvider, temp);
        }
        samplePromise.then(() => {
            for (let n = 0; n < temp.length; ++n) {
                let coord = Cesium.Cartesian3.fromRadians(temp[n].longitude, temp[n].latitude, temp[n].height);
                this.entityHelper.addEntity(global_1.AnnotationType.volumepoint, { coord: coord }, 'volumepoint', 'volume_calc');
            }
            if (chunk < gridPositionsCartographic.length) {
                chunk += slice;
                ths.batchSize += slice;
                temp = gridPositionsCartographic.slice(ths.batchSize, chunk);
                this.makeSamplePromise(model, ths, gridPositionsCartographic.length, temp, objectsToExclude, chunk, slice, gridPositionsCartographic, Vol, samplingDistance, polyVertices, tinTriangles);
            }
            else {
                var pointHeights = [];
                for (var n = 0; n < gridPositionsCartographic.length; ++n) {
                    pointHeights.push(gridPositionsCartographic[n].height);
                }
                var minHeight = Math.min(...pointHeights);
                // var maxHeight = Math.max(...pointHeights);
                /* for (n = 0; n < gridPositionsCartographic.length; ++n) {
                  let coord = Cesium.Cartesian3.fromRadians(gridPositionsCartographic[n].longitude, gridPositionsCartographic[n].latitude, gridPositionsCartographic[n].height);
                  this.mapService.viewer.entities.add({
                    name: 'Red cone',
                    position: coord,
                    point: {
                      pixelSize: 5,
                      color: Cesium.Color.GREEN
                    },
                  });
                } */
                //base surface options
                //for triangulated base surface
                if (this.volumeChoiceOption === this.baseSurface) {
                    var sumOfPositives = 0;
                    var sumOfNegatives = 0;
                    // console.log('points length ' + gridPositionsCartographic.length);
                    for (n = 0; n < gridPositionsCartographic.length; ++n) {
                        for (var i = 0, len = tinTriangles.length; i < len; i++) {
                            var triangle = tinTriangles[i];
                            var plane = triangle.plane;
                            var cartesian = triangle.cartesian3;
                            var projected = triangle.projected;
                            var vLongs = projected.map(p => p.longitude);
                            var vLats = projected.map(p => p.latitude);
                            var point = new Cesium.Cartographic(gridPositionsCartographic[n].longitude * 180 / Math.PI, gridPositionsCartographic[n].latitude * 180 / Math.PI);
                            if (this.pointInsidePolygon(point, vLongs, vLats)) {
                                var p = Cesium.Cartesian3.fromDegrees(gridPositionsCartographic[n].longitude * 180 / Math.PI, gridPositionsCartographic[n].latitude * 180 / Math.PI, gridPositionsCartographic[n].height);
                                var planeDist = -1 * Cesium.Plane.getPointDistance(plane, p);
                                this.finalCalculatedPoints.push({ index: n, cartesianPoint: coord_helper_service_1.CoordGeodetic.toPlain(p), cartographicPoint: coord_helper_service_1.CoordGeodetic.toPlain(gridPositionsCartographic[n]), height: gridPositionsCartographic[n].height, planeDistance: planeDist, difference: null });
                                if (planeDist < 0) {
                                    sumOfNegatives += -1 * planeDist;
                                    // draw line down
                                }
                                else {
                                    sumOfPositives += planeDist;
                                    // draw line up
                                }
                                /*this.mapService.viewer.entities.add({
                                  name: 'Red cone',
                                  position: Cesium.Cartesian3.fromRadians(gridPositionsCartographic[n].longitude, gridPositionsCartographic[n].latitude, gridPositionsCartographic[n].height),
                                  point: {
                                    pixelSize: 5,
                                    color: Cesium.Color.YELLOW
                                  },
                                });
                */
                                break;
                            }
                            else {
                            }
                        }
                    }
                    var posVol = (sumOfPositives * samplingDistance * samplingDistance);
                    var negVol = (sumOfNegatives * samplingDistance * samplingDistance);
                    var totalVol = ((sumOfPositives - sumOfNegatives) * samplingDistance * samplingDistance);
                    this.setVolumeValue(totalVol, posVol, negVol);
                    this.setVolumePoints();
                    this.endCalculating();
                    this.entityHelper.destroyEntitiesByCaller('volume_calc');
                    this.finished();
                }
                else if (this.volumeChoiceOption === this.minHeight) { //for min height base surface
                    for (n = 0; n < gridPositionsCartographic.length; ++n) {
                        Vol += gridPositionsCartographic[n].height - minHeight;
                        var p = Cesium.Cartesian3.fromDegrees(gridPositionsCartographic[n].longitude * 180 / Math.PI, gridPositionsCartographic[n].latitude * 180 / Math.PI, gridPositionsCartographic[n].height);
                        this.finalCalculatedPoints.push({ index: n, cartesianPoint: coord_helper_service_1.CoordGeodetic.toPlain(p), cartographicPoint: coord_helper_service_1.CoordGeodetic.toPlain(gridPositionsCartographic[n]), height: gridPositionsCartographic[n].height, planeDistance: null, difference: null });
                    }
                    Vol = Vol * samplingDistance * samplingDistance;
                    //  this.calculatedVolume = Vol.toFixed(3);
                    this.setVolumeValue(Vol.toFixed(3));
                    this.setVolumePoints();
                    this.endCalculating();
                    this.entityHelper.destroyEntitiesByCaller('volume_calc');
                    this.finished();
                }
                else if (this.volumeChoiceOption === this.customHeight) { //for custom height base surface
                    var sumOfPositives = 0;
                    var sumOfNegatives = 0;
                    for (n = 0; n < gridPositionsCartographic.length; ++n) {
                        if (gridPositionsCartographic[n].height - this.customHeightValue < 0) {
                            sumOfNegatives += -1 * gridPositionsCartographic[n].height - this.customHeightValue;
                        }
                        else {
                            sumOfPositives += gridPositionsCartographic[n].height - this.customHeightValue;
                        }
                        var p = Cesium.Cartesian3.fromDegrees(gridPositionsCartographic[n].longitude * 180 / Math.PI, gridPositionsCartographic[n].latitude * 180 / Math.PI, gridPositionsCartographic[n].height);
                        this.finalCalculatedPoints.push({ index: n, cartesianPoint: coord_helper_service_1.CoordGeodetic.toPlain(p), cartographicPoint: coord_helper_service_1.CoordGeodetic.toPlain(gridPositionsCartographic[n]), height: gridPositionsCartographic[n].height, planeDistance: null, difference: null });
                    }
                    var posVol = (sumOfPositives * samplingDistance * samplingDistance);
                    var negVol = (sumOfNegatives * samplingDistance * samplingDistance);
                    var totalVol = ((sumOfPositives - sumOfNegatives) * samplingDistance * samplingDistance);
                    this.setVolumeValue(totalVol, posVol, negVol);
                    this.endCalculating();
                    this.entityHelper.destroyEntitiesByCaller('volume_calc');
                    this.finished();
                }
                else if (this.volumeChoiceOption === this.baseDesign) {
                    var baseTemp;
                    chunk = 200;
                    slice = 200;
                    ths.batchSize = 0;
                    var baseGridPositionsCartographic = [];
                    gridPositionsCartographic.forEach((item) => {
                        baseGridPositionsCartographic.push(Object.assign({}, item));
                    });
                    if (baseGridPositionsCartographic.length < chunk) {
                        chunk = baseGridPositionsCartographic.length;
                    }
                    baseTemp = baseGridPositionsCartographic.slice(0, chunk);
                    this.removeTransformTemporarily();
                    setTimeout(() => {
                        // if base transform is not plotted then add in cesium so that it can be consider
                        if (!this.mapService.helper.getCesiumObjectFor(this.baseDesignTransform)) {
                            this.mapService.helper.addPlottable(this.baseDesignTransform).subscribe(v => {
                                this.makeSamplePromiseBaseDesign(this.mapService.viewer.scene, this, baseGridPositionsCartographic.length, baseTemp, objectsToExclude, chunk, slice, baseGridPositionsCartographic, Vol, samplingDistance, gridPositionsCartographic);
                            });
                        }
                        else {
                            this.makeSamplePromiseBaseDesign(this.mapService.viewer.scene, this, baseGridPositionsCartographic.length, baseTemp, objectsToExclude, chunk, slice, baseGridPositionsCartographic, Vol, samplingDistance, gridPositionsCartographic);
                        }
                    }, 1000);
                }
                /*
                console.log(minHeight);
                try {
                  if (this.annotation['pointsProps'][this.currentPointsIndex].findIndex(e => e['measuredValue']) !== -1) {
                    this.annotation['pointsProps'][this.currentPointsIndex][this.annotation['pointsProps'][this.currentPointsIndex].findIndex(e => e['measuredValue'])]['measuredValue']  = this.calculatedVolume;
                  }else{
                    this.annotation['pointsProps'][this.currentPointsIndex].push({ 'measuredValue' : this.calculatedVolume})
                  }
                  this.annotation['pointsProps'][this.currentPointsIndex][this.annotation['pointsProps'][this.currentPointsIndex].findIndex(e => e['measuredValue'])]['measuredValue'] = this.calculatedVolume;
                } catch (e) {
                  console.log(e);
                }
                if (this.mapComp.currentCoord && this.annotation) {
                  this.annotation['calculatedVolume'] = this.calculatedVolume;
                }
                */
            }
        });
    }
    setVolumeValue(totalVol, posVol = null, negVol = null) {
        if (!this.shapes[this.shapeMaker.selectedShape].calc) {
            this.shapes[this.shapeMaker.selectedShape].calc = {};
        }
        this.shapes[this.shapeMaker.selectedShape].calc['volume'] = totalVol;
        if (posVol) {
            this.shapes[this.shapeMaker.selectedShape].calc['volumePos'] = posVol;
        }
        if (negVol) {
            this.shapes[this.shapeMaker.selectedShape].calc['volumeNeg'] = negVol;
        }
        // this.calculatedVolume = 'Positive Volume (Cut) : ' + posVol + ' cubic meter  \n Negative Volume (Fill) : ' + negVol + ' cubic meter \n Total Volume Balance : ' + totalVol + ' cubic meter';
    }
    setVolumePoints() {
        if (!this.shapes[this.shapeMaker.selectedShape].calc) {
            this.shapes[this.shapeMaker.selectedShape].calc = {};
        }
        this.shapes[this.shapeMaker.selectedShape].calc['volumePoints'] = this.finalCalculatedPoints;
        /* should be safe, but if not, continue the below conversion ...
        this.finalCalculatedPoints.forEach ( p => {
          this.shapes[this.shapeMaker.selectedShape].calc['volumePoints'].push();
        }); */
    }
    makeSamplePromiseBaseDesign(model, ths, len, baseTemp, objectsToExclude, chunk, slice, baseGridPositionsCartographic, Vol, samplingDistance, gridPositionsCartographic) {
        this.calculatingVolumePercent = ((chunk * 100) / len);
        var samplePromise;
        samplePromise = model.sampleHeightMostDetailed(baseTemp, objectsToExclude, 0.05);
        samplePromise.then(() => {
            if (chunk < baseGridPositionsCartographic.length) {
                chunk += slice;
                ths.batchSize += slice;
                baseTemp = baseGridPositionsCartographic.slice(ths.batchSize, chunk);
                this.makeSamplePromiseBaseDesign(model, ths, baseGridPositionsCartographic.length, baseTemp, objectsToExclude, chunk, slice, baseGridPositionsCartographic, Vol, samplingDistance, gridPositionsCartographic);
            }
            else {
                var sumOfPositives = 0, sumOfNegatives = 0;
                for (var n = 0; n < baseGridPositionsCartographic.length; ++n) {
                    var diff = gridPositionsCartographic[n].height - baseGridPositionsCartographic[n].height;
                    if (diff < 0) {
                        sumOfNegatives += -1 * diff;
                    }
                    else {
                        sumOfPositives += diff;
                    }
                    var p = Cesium.Cartesian3.fromDegrees(baseGridPositionsCartographic[n].longitude * 180 / Math.PI, baseGridPositionsCartographic[n].latitude * 180 / Math.PI, baseGridPositionsCartographic[n].height);
                    this.finalCalculatedPoints.push({ index: n, cartesianPoint: coord_helper_service_1.CoordGeodetic.toPlain(p), cartographicPoint: coord_helper_service_1.CoordGeodetic.toPlain(baseGridPositionsCartographic[n]), height: baseGridPositionsCartographic[n].height, planeDistance: null, difference: diff });
                }
                var posVol = (sumOfPositives * samplingDistance * samplingDistance);
                var negVol = (sumOfNegatives * samplingDistance * samplingDistance);
                var totalVol = ((sumOfPositives - sumOfNegatives) * samplingDistance * samplingDistance);
                this.setVolumeValue(posVol, negVol, totalVol);
                this.calculatingVolume = false;
                try {
                    this.annotation['pointsProps'][this.currentPointsIndex][this.annotation['pointsProps'][this.currentPointsIndex].findIndex(e => e['measuredValue'])]['measuredValue'] = this.calculatedVolume;
                }
                catch (e) {
                    console.log(e);
                }
                if (this.mapComp.currentCoord && this.annotation) {
                    this.annotation['calculatedVolume'] = this.calculatedVolume;
                }
                this.addTransformBack();
            }
        });
    }
    pointInsidePolygon(point, vX, vY) {
        // ray-casting algorithm http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
        var x = point.longitude, y = point.latitude;
        var inside = false;
        for (var i = 0, j = vX.length - 1; i < vX.length; j = i++) {
            var xi = vX[i], yi = vY[i];
            var xj = vX[j], yj = vY[j];
            var intersect = ((yi >= y) != (yj >= y))
                && (x <= (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) {
                inside = !inside;
            }
        }
        return inside;
    }
    addVolumeBase(posis, lineWidth, color) {
        color.alpha = 0.5;
        var line = this.mapService.viewer.entities.add({
            name: 'volumeBase',
            polygon: {
                hierarchy: posis,
                outline: true,
                outlineWidth: lineWidth,
                perPositionHeight: !this.clampToModel,
                clampToGround: this.clampToModel,
                classificationType: Cesium.ClassificationType.BOTH,
                outlineColor: Cesium.Color.WHITE,
                material: color
            }
        });
        return line;
    }
    removeTransformTemporarily() {
        // remove all but the baseDesign
        this.sceneTransformsActive = [];
        this.mapService.sceneTransforms.forEach(p => {
            if (this.mapService.scene['layerProps'][map_service_1.MapService.TOGGLE + p.id] && p.id !== this.baseDesignTransform.id) {
                this.sceneTransformsActive.push(p);
                if (!this.sceneTransformsActiveViews[p.id]) {
                    this.sceneTransformsActiveViews[p.id] = true;
                }
                this.toggleView(p);
            }
            // if ( p.id !== this.baseDesignTransform.id ) {
            // this.toggleView(p);
            // this.mapService.helper.removePlottable(t);
            // }
        });
    }
    addTransformBack() {
        this.sceneTransformsActive.forEach(p => {
            this.toggleView(p);
        });
        this.sceneTransformsActive = [];
        this.sceneTransformsActiveViews = {};
        /*
        // find all viewables that are not the baseDesign
        var toPlot = this.mapService.sceneTransforms.filter(p =>
          (this.mapService.scene['layerProps'][MapService.TOGGLE + p.id] && p.id !== this.baseDesignTransform.id)
        )
    
        // set opacity and order for all those transforms
        toPlot.forEach(t => {
          if (!this.mapService.helper.getCesiumObjectFor(t)) {
            this.mapService.helper.addPlottable(t).subscribe(_ => {
              this.mapService.changeOpacity(t);
              this.mapService.reorderTransform();
            })
          }
        })
    
        // remove baseDesign if it wasn't plotted
        if (!this.mapService.scene['layerProps'][MapService.TOGGLE + this.baseDesignTransform.id]) {
          this.mapService.helper.removePlottable(this.baseDesignTransform);
        }
        */
    }
    toggleView(t, toggleButNotShow = false) {
        let e = this.mapService.helper.getCesiumObjectFor(t);
        if (e) {
            this.sceneTransformsActiveViews[t.id] = !this.sceneTransformsActiveViews[t.id];
            if (!toggleButNotShow) {
                e.show = this.sceneTransformsActiveViews[t.id];
            }
            this.mapService.scene['layerProps'][map_service_1.MapService.VIEW + t.id] = this.sceneTransformsActiveViews[t.id];
        }
    }
    takeScreenShotForVolume() {
        // configure settings
        this.takingScreenShot = true;
        // define callback functions
        this.prepareScreenshotFunction = this.prepareScreenshot.bind(this);
        this.mapService.viewer.scene.preRender.addEventListener(this.prepareScreenshotFunction);
    }
    prepareScreenshot() {
        var canvas = this.mapService.viewer.scene.canvas;
        this.mapService.viewer.scene.preRender.removeEventListener(this.prepareScreenshotFunction);
        // take snapshot after defined timeout to allow scene update (ie. loading data)
        setTimeout(() => {
            this.takeScreenshotFunction = this.takeScreenshot.bind(this);
            this.mapService.viewer.scene.postRender.addEventListener(this.takeScreenshotFunction);
        }, this.timeout);
    }
    takeScreenshot() {
        this.mapService.viewer.scene.postRender.removeEventListener(this.takeScreenshotFunction);
        var canvas = this.mapService.viewer.scene.canvas;
        canvas.toBlob((blob) => {
            var url = URL.createObjectURL(blob);
            this.canvasUrl = this.sanitize(url);
            this.takingScreenShot = false;
        });
    }
    sanitize(url) {
        return this.domSanitizer.bypassSecurityTrustUrl(url);
    }
    downloadURI(uri, name) {
        var link = document.createElement('a');
        link.download = name;
        link.href = uri;
        // mimic click on "download button"
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // delete link;
    }
}
exports.VolumeComponent = VolumeComponent;
